export default "__VITE_ASSET__BhwQ3gXm__"